import { render } from "./FlightDealsSection.vue?vue&type=template&id=041db821"
import script from "./FlightDealsSection.vue?vue&type=script&lang=js"
export * from "./FlightDealsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__